export enum BookingTypes {
    Internal = 'Internbokning',
    Intermediate = 'Förmedlingsbokning',
}